import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { CompetencyWithEvaluation } from '../../types/GrowthWheel'
import { setCurrentCompetency, setCurrentCompetencyArea } from '../../redux/growthWheel.slice'
import DisplayLevelComponent from './DisplayLevelComponent'
import { RichTextView } from './RichTextView'



const AreasOfFocus = () => {
    const dispatch = useDispatch()
    const currentAreasOfFocus = useSelector((state: RootState) => state.growthWheel.currentAreasOfFocus)
    const userCompetencyAreasData = useSelector((state: RootState) => state.growthWheel.userCompetencyAreasData)

    const handleFocusCompetencyClick = (competency: CompetencyWithEvaluation) => {
        const competencyArea = userCompetencyAreasData.find((area) => area.competencies?.some((areaCompetency) => areaCompetency.id === competency.id))
        if (competencyArea) {
            dispatch(setCurrentCompetencyArea(competencyArea))
            dispatch(setCurrentCompetency(competency))
        }
    }

    const focusTitle= () => {
        return currentAreasOfFocus.length > 0 ? `Your Areas of Focus (${currentAreasOfFocus.length}/3)` : 'No areas of focus selected yet. Start marking sub-competencies to build your growth plan.'
    }

    return (
        <div className='gw-areas-of-focus-container'>
            <div className='gw-areas-of-focus-header '>
                <FontAwesomeIcon
                className='text-warning'
                    icon={faStarSolid}
                    style={{ fontSize: '0.8rem' }}
                />
                <span>{focusTitle()}</span>
            </div>
            <div className='gw-areas-of-focus-list'>
                {currentAreasOfFocus.map((competency) => (
                    <button
                        key={competency.id}
                        onClick={() => handleFocusCompetencyClick(competency)}
                        className="gw-areas-of-focus-item"
                    >
                        <div className="gw-areas-of-focus-item-inner">
                            <FontAwesomeIcon
                                icon={faStarSolid}
                                style={{ fontSize: '0.8rem', paddingTop: '0.2rem' }}
                                className='text-warning'
                            />
                            <div className="gw-areas-of-focus-item-content">
                                <div className="gw-areas-of-focus-item-header">
                                    <h4 className="gw-areas-of-focus-item-title">{competency.name}</h4>
                                    <span className="gw-areas-of-focus-item-area">
                                        {competency.areaName}
                                    </span>
                                </div>
                                <RichTextView
                                    className="gw-areas-of-focus-item-description"
                                    html={competency.description}
                                />
                                <div className="d-flex align-items-center gap-3 flex-wrap">
                                    <DisplayLevelComponent label="Self" level={competency.evaluation?.selfLevel ?? null} />
                                    <DisplayLevelComponent className="gw-competency-view-level-value--guided" label="Guided" level={competency.evaluation?.leaderLevel ?? null} />
                                </div>
                            </div>
                            <FontAwesomeIcon icon={faChevronRight} className="gw-competency-view-chevron" />
                        </div>
                    </button>
                ))}
            </div>
        </div>
    )
}

export default AreasOfFocus